import React from "react";
import MobileTabBarContainer from "./containers/MobileTabBarContainer";
import CurrentInput from "./containers/CurrentInput";
import Results from "./Results";
import CurrentOutput from "./containers/CurrentOutput";

const MobileLayout = ({ selectedTab = "Input" }) => {
  const inputContent = selectedTab === "Input" ? <CurrentInput /> : null;
  const resultsContent = selectedTab === "Results" ? <Results /> : null;
  const outputContent = selectedTab === "Output" ? <CurrentOutput /> : null;

  return (
    <div className="MobileLayout">
      <MobileTabBarContainer />
      <div className="mobileContent">
        {inputContent}
        {resultsContent}
        {outputContent}
      </div>
    </div>
  );
};

export default MobileLayout;



// WEBPACK FOOTER //
// ./src/MobileLayout.js